module.exports = __webpack_public_path__ + "static/capture2-c3f8c148cbc71d0084da4a8ac6c6b044.png";